module.exports = __webpack_public_path__ + "img/icon-32-ic-done-oval.14eda172.svg";